/**
 * Created by Allan on 2021/11/03.
 * Contact 84880528@qq.com.
 * 获取url参数
 */
export default function(name){
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const r = window.location.hash.split('?')[1].match(reg);
    if (r !== null) return decodeURIComponent(r[2]); return null;
}



// WEBPACK FOOTER //
// ./src/baseloan/service/getQueryVariable.js